const housingData = [];

export const getHousingById = (id) => {
  return housingData.find((item) => item.id === parseInt(id));
};

export const getLocations = () => {
  const locations = [...new Set(housingData.map((item) => item.district))];
  return locations.sort();
};

export const getCities = () => {
  const cities = [...new Set(housingData.map((item) => item.city))];
  return cities.sort();
};

export default housingData;